<template>
  <li
    class="LeftNav__Item"
    :class="{
      opened: opened,
    }"
  >
    <a
      class="flex items-center text-sm cursor-pointer"
      :class="{ 'font-bold': active }"
      @click="openItem($event)"
      v-if="!$slots.link"
    >
      <span class="mr-2">
        <aw-icon
          v-if="isLoading"
          icon="loading"
          class="animate-spin w-4 h-4 "
        />
        <aw-icon
          :icon="icon"
          class="w-4 h-4"
          :class="{
            '': iconFillCurrent,
            '': !iconFillCurrent
          }"
          v-else-if="icon"
        ></aw-icon>
        <span class="w-4" v-else></span>
      </span>
      <span class="flex-grow VisibleAlways">{{ title }}</span>
      <span
        class="mr-2"
        v-if="item.type === 'domain' || (item.type === 'folder' && (item.id in bcMoveCopyStore.listChildrenFolders || ($route.matched[0].name === 'BCDocument' && item.id in bcMoveCopyStore.listChildren)))"
      >
        <aw-icon
          icon="chevron-right"
          class="w-4 h-4 "
          v-if="$attrs.id"
        ></aw-icon>
      </span>
    </a>
    <slot v-else name="link" v-bind="{ open }" />
    <ul v-if="$slots.default">
      <teleport :to="'#MoveCopyStep' + $attrs.id" v-if="opened">
        <slot />
      </teleport>
    </ul>
  </li>
</template>
<script>
import { mapStores } from 'pinia'
import bcMoveCopyStore from '@/frontapp/store/bcMoveCopy'

export default {
  name: 'NavItem',
  props: ['title', 'url', 'icon', 'iconFillCurrent', 'item', 'selectedAction'],
  inject: ['addNavStep', 'openNavStep', 'openedNavStepIds'],
  data() {
    return {
      isLoading: false,
    }
  },
  mounted() {
    if (this.$slots.default) {
      this.addNavStep(this.$attrs.id)
    }
  },
  computed: {
    opened() {
      return (
        this.$attrs.id &&
        this.openedNavStepIds.value.indexOf(this.$attrs.id) !== -1
      )
    },
    active() {
      if (!this.bcMoveCopyStore.selectedItem) {
        return false
      }

      if (this.$route.matched[0].name === 'BCFolder' || this.$route.matched[0].name === 'BCHome' || this.selectedAction === 'link') {
        return this.bcMoveCopyStore.selectedItem.id === this.item.id && this.bcMoveCopyStore.selectedItem.type === this.item.type
      }

      // for move / copy documents
      return this.bcMoveCopyStore.selectedItem.id === this.item.id && this.bcMoveCopyStore.selectedItem.type === this.item.type && this.item.type === 'document'
    },
    ...mapStores(bcMoveCopyStore)
  },
  methods: {
    async openItem(event) {
      event.stopPropagation()
      event.preventDefault()

      if (this.item.type === 'folder') {
        this.isLoading = true
        await this.bcMoveCopyStore.loadFolder(this.item.id)
        // jenom tehdy ma-li dalsi podslozky
        if ((this.item.id in this.bcMoveCopyStore.listChildrenFolders) || (this.$route.matched[0].name === 'BCDocument' && this.item.id in this.bcMoveCopyStore.listChildren)) {
          this.openNavStep(this.title, this.icon, this.$attrs.id)
        }
        this.isLoading = false
      
      } else if (this.item.type === 'domain') {
        this.isLoading = true
        this.bcMoveCopyStore.selectedDomain = this.item
        await this.bcMoveCopyStore.loadFolder(0)
        this.isLoading = false
      }

      this.bcMoveCopyStore.selectedItem = this.item
    }
  }
}
</script>
